export const sortEntityByName = (array: EntityBase[]) => {
  return [...array]
    .filter((item) => !!item)
    .sort(({ name: nameA }, { name: nameB }) => {
      return nameA.localeCompare(nameB);
    });
};
